import { useMemo, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../lib/store';
import { useGetSupervisorsQuery } from '../../api/createProjectApiSlice';
import { addSelectedSupervisor, removeSelectedSupervisor } from '../../state/createProjectSlice';
import { selectSelectedSupervisors } from '../../state/selector';
import { SupervisorResponse } from '../../types/response';

interface UseSupervisorSelectionResults {
  supervisors: SupervisorResponse[];
  selectedSupervisors: SupervisorResponse[];
  handleAddSupervisor: (supervisor: SupervisorResponse) => void;
  handleRemoveSupervisor: (supervisor: SupervisorResponse) => void;
  supervisorInputValue: string;
  lastTypedSupervisorValue: React.MutableRefObject<string>;
  setSupervisorInputValue: (value: string) => void;
  isSupervisorsLoading: boolean;
}

export const useSupervisorSelection = (): UseSupervisorSelectionResults => {
  const {
    data: supervisorsData,
    isLoading: isSupervisorsLoading,
    isFetching: isSupervisorsFetching,
  } = useGetSupervisorsQuery();
  const supervisors = useMemo(() => supervisorsData?.data ?? [], [supervisorsData]);

  const dispatch = useAppDispatch();
  const selectedSupervisors = useAppSelector(selectSelectedSupervisors);

  const handleAddSupervisor = (supervisor: SupervisorResponse) => {
    dispatch(addSelectedSupervisor(supervisor));
  };
  const handleRemoveSupervisor = (supervisor: SupervisorResponse) => {
    dispatch(removeSelectedSupervisor(supervisor.id));
  };
  const [supervisorInputValue, setSupervisorInputValue] = useState<string>('');

  const lastTypedSupervisorValue = useRef<string>('');
  return {
    selectedSupervisors,
    handleRemoveSupervisor,
    supervisors,
    supervisorInputValue,
    lastTypedSupervisorValue,
    setSupervisorInputValue,
    handleAddSupervisor,
    isSupervisorsLoading: isSupervisorsLoading || isSupervisorsFetching,
  };
};
